<!--
  删除组员
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('transfer.delTeamMembers')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <scroll>
        <div class="list-member">
          <van-cell
            v-for="(item, index) in listMember"
            :key="index"
            :icon="httpUrl + item.avatar"
            :title="item.username"
            :label="_phoneDispose(item.phone)"
          >
            <van-icon
              name="clear"
              @click="clickClear(item, index)"
              slot="right-icon"
            />
          </van-cell>
        </div>
      </scroll>
    </div>
    <div class="button-wrap button-fixed">
      <van-button block type="primary" @click="delMember">
        {{ $t("common.save") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {
      listMember: []
    };
  },
  created() {
    this.getListMember();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:membersDelFlag", false);
    },
    clickClear(data, index) {
      let vm = this;
      vm.listMember.splice(index, 1);
    },
    delMember() {
      let vm = this;
      let arrId = [];
      for (let i = 0; i < vm.listMember.length; i++) {
        arrId.push(vm.listMember[i].user_id);
      }
      console.log(arrId.toString());
      let params = {};
      params.group_id = vm.groupId;
      params.user_id = arrId.toString();
      vm.$post("/app/transfer/delMember", params, { loading: true }).then(
        res => {
          console.log("delMember", res);
          vm.$emit("update:membersDelFlag", false);
          vm.$emit("getListMember");
        }
      );
    },
    getListMember() {
      // 获取群组成员
      let vm = this;
      vm.$post(
        "/app/transfer/listMember",
        { group_id: vm.groupId },
        { loading: true }
      ).then(res => {
        console.log("listMember", res);
        vm.listMember = res.list;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  bottom: 85px;
}
.list-member {
  padding: 0 15px;
  /deep/.van-cell {
    position: relative;
    align-items: center;
    padding: 10px 0;
    &::after {
      left: 54px;
    }
    .van-cell__left-icon {
      margin-right: 10px;
      width: 44px;
      height: 44px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
      img {
        width: 44px;
        height: 44px;
        border-radius: 4px;
      }
    }
    .van-icon-clear {
      font-size: 20px;
      color: #cdcdcd;
    }
  }
}
</style>
